import { Component, ViewChild } from "@angular/core";
import { BaseComponent } from "../../../base.component";
import { PaymentTypes } from "../../../_models/index";
import { SelectAreaComponent } from "../../components/select-area/select-area.component";
import { AutoCompleteComponent } from "../../components/auto-complete/auto-complete.component";
import { BooleanComponent } from "../../components/boolean/boolean.component";

import * as _ from "lodash";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "openreceipts",
  templateUrl: "open-receipts.component.html",
  styleUrls: ["./open-receipts.component.css"],
})
export class OpenReceiptsComponent extends BaseComponent {
  @ViewChild("circleselect") circleSelect: SelectAreaComponent;
  @ViewChild("childselect") childSelect: AutoCompleteComponent;
  @ViewChild("userselect") userSelect: AutoCompleteComponent;
  @ViewChild("chequesOnly") chequesOnly: BooleanComponent;
  @ViewChild("notCompletelyDeposited")
  notCompletelyDeposited: BooleanComponent;
  myEventsCash: any[];
  myEventsCheque: any[];
  othersEventsCash: any[];
  othersEventsCheque: any[];

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  run() {
    this.getOpenReceipts({ init: true });
  }

  getOpenReceipts(filter: any) {
    if (!this.loading) {
      this.loading = true;
      this.othersEventsCash = [];
      this.othersEventsCheque = [];
      // this.myEventsCash = [];
      // this.myEventsCheque = [];
      this.dataService.postEntity("open-receipts", filter).subscribe(
        (data) => {
          if (data && data.myEvents) {
            this.filterEvents(data.myEvents, true);
          }
          // 	              	this.myEvents = data.myEvents;
          if (data && data.othersEvents) {
            this.filterEvents(data.othersEvents, false);
          }
          // 	              	this.othersEvents = data.othersEvents;
          this.loading = false;
        },
        (error) => {
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.base.messages[body.statusText]
                ? this.base.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
          this.loading = false;
        }
      );
    }
  }

  filterEvents(events, isMyEvents) {
    let cashEvents = [];
    let chequeEvents = [];
    if (events && events.length) {
      events.forEach((ev) => {
        if (ev.paymentType === PaymentTypes.PAYMENT_TYPE_CASH) {
          cashEvents.push(ev);
        } else if (ev.paymentType === PaymentTypes.PAYMENT_TYPE_CHEQUE) {
          chequeEvents.push(ev);
        }
      });

      if (isMyEvents) {
        this.myEventsCash = cashEvents;
        this.myEventsCheque = chequeEvents;
      } else {
        this.othersEventsCash = cashEvents;
        this.othersEventsCheque = chequeEvents;
      }
    }
  }

  public depositCompleted(adminUser: number) {
    let isItThisUser = adminUser === this.base.user.token;
    if (isItThisUser) {
      this.myEventsCash = [];
      this.myEventsCheque = [];
      this.getOpenReceipts({ init: true });
    } else {
      this.legacySearch_Receipts();
    }
  }

  public legacySearch_Receipts() {
    let postData = _.merge(
      this.circleSelect.submit(),
      this.userSelect ? this.userSelect.submit() : {},
      this.childSelect.submit(),
      this.chequesOnly.submit(),
      this.notCompletelyDeposited.submit()
    );
    this.getOpenReceipts(postData);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/teshlumon/open-receipts/open-receipts.component.ts